import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTasksState } from "../store/tasks/selectors";
import { getTaskActivitiesByTaskId } from "../store/tasks/thunks";

export const useTaskActivities = (task, tenant_id) => {
  const dispatch = useDispatch();
  const { activityLoading: loading, columnsByTenants } =
    useSelector(selectTasksState);

  const { id: taskId, column_id: columnId } = task;

  const activities = useMemo(() => {
    const tasks = columnsByTenants?.[tenant_id]?.[columnId]?.tasks;
    return tasks?.find((t) => t.id === taskId)?.activities ?? [];
  }, [columnsByTenants, tenant_id, columnId, taskId]);

  const fetchActivities = useCallback(
    (offset = 0) => {
      if (!taskId || !columnId || loading) return;

      dispatch(
        getTaskActivitiesByTaskId({
          task_id: taskId,
          column_id: columnId,
          tenant_id,
          offset,
        }),
      );
    },
    [dispatch, taskId, columnId, tenant_id],
  );

  return {
    loading,
    activities,
    fetchActivities,
  };
};
